/*
 *  -----------------------------------------------------------------------
 *    <copyright file="auth.service.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */
import LocalStorage from '@utils-clean/local-storage-service';
import ApiLogout from 'apis/logout';
import { LocalContextPersistedKey } from '@contexts/local-state-context';

const logout = (client: any, userContext: any, options: string) => {
    let sessionStorage: any;
    try {
        sessionStorage = window.sessionStorage;
    } catch (e) {
        if (!sessionStorage) console.warn('No session storage available.');
    }

    if (userContext.clearToken) userContext.clearToken();

    const isPopoutPage = sessionStorage
        ? sessionStorage.getItem(LocalContextPersistedKey.LockedToOrgKey) !== null
        : false;

    // Setting this value here will cause all the events that are monitoring this local storage key to fire and causing other windows
    // to log out, before immediately removing it.
    if (!isPopoutPage) {
        LocalStorage.setItem(userContext.user, 'IsLoggingOut', true);
        LocalStorage.clear(userContext.user);
    }
    LocalStorage.setItem(userContext.user, 'LastLogoutReason', options);

    if (sessionStorage) sessionStorage.clear();

    if (client) {
        client.clearStore().then(() => {
            client.cache.reset();
        });
    }

    // And take them back to login
    const initialLoginLink =
        !userContext.user.systemAdminLevel && userContext.user.organisation
            ? `/login/${userContext.user.organisation.loginCode}`
            : '/login';
    let reason = '';

    if (options && options === 'ForceLogout') reason = 'forceLogout';
    if (options && options === 'EmailVerification') reason = 'email-verification';
    if (options && options === 'MaxAttemptsFailed') reason = 'max-attempts-failed';

    const search = `?${reason}=true`;

    window.location.href = reason ? initialLoginLink + search : initialLoginLink;
};

const doLogout = (client: any, user: any, options: string) => {
    ApiLogout(user.token)
        .then(() => {
            logout(client, user, options);
        })
        .catch((err) => {
            console.log('err', err);
            logout(client, user, options);
        });
};

export default doLogout;
